module.exports = __webpack_public_path__ + "images/emoji/boy.65db0b021a7d9746db47.png";